import { render, staticRenderFns } from "./DeskItem.vue?vue&type=template&id=81cdec4c&scoped=true"
import script from "./DeskItem.vue?vue&type=script&lang=js"
export * from "./DeskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cdec4c",
  null
  
)

export default component.exports